import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import { FaArrowRight } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import "./ContactForm.css";

const ContactForm = () => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      toast.error("Lütfen reCAPTCHA doğrulamasını yapın.");
      return;
    }

    const form = e.target;

    const data = {
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      message: form.message.value,
      recaptchaToken,
    };

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(data.email)) {
      toast.error("Geçerli bir e-posta adresi giriniz.");
      return;
    }

    try {
      const response = await fetch(
        `https://api.airtable.com/v0/${process.env.REACT_APP_AIRTABLE_BASE_ID}/${process.env.REACT_APP_AIRTABLE_TABLE_NAME}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_TOKEN}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            records: [
              {
                fields: {
                  "Ad Soyad": data.name,
                  "Email": data.email,
                  "Telefon": data.phone,
                  "Mesaj": data.message,
                  "KVKK Onay": "Evet",
                  "Tarih": new Date().toISOString(),
                },
              },
            ],
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Sunucu hatası: ${response.status}`);
      }

      toast.success("Mesajınız alındı.");
      form.reset();
      setRecaptchaToken(null);
      recaptchaRef.current?.reset();
    } catch (error) {
      console.error("Hata:", error);
      toast.error("Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.");
    }
  };

  return (
    <div className="contact-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input type="text" name="name" placeholder="Ad Soyad" required />
        </div>
        <div className="form-group">
          <input type="email" name="email" placeholder="E-posta" required />
        </div>
        <div className="form-group">
          <input type="tel" name="phone" placeholder="Telefon Numarası" required />
        </div>
        <div className="form-group">
          <textarea name="message" placeholder="Mesajınız" required />
        </div>

        <div className="form-group">
          <div className="contact-kvkk-consent">
            <label>
              <input type="checkbox" name="kvkkOnay" required />
              <span><Link to="/kvkk" target="_blank">KVKK</Link>'yı ve <Link to="/aydinlatma-metni" target="_blank">Aydınlatma Metni</Link>'ni okudum ve anladım.</span>
            </label>
          </div>
        </div>

        <div className="form-group">
          <div className="contact-form-recaptcha-container">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={(token) => setRecaptchaToken(token)}
            onExpired={() => {
              setRecaptchaToken(null);
              toast.warning("reCAPTCHA süresi doldu, lütfen tekrar doğrulayın.");
            }}
            onErrored={() => {
              setRecaptchaToken(null);
              toast.error("reCAPTCHA yüklenemedi. Sayfayı yenileyin.");
            }}
          />
          </div>
        </div>

        <div className="form-group">
          <button type="submit" className="submit-button">
            Mesaj Gönder <FaArrowRight className="arrow-icon" />
          </button>
        </div>
      </form>

      <ToastContainer position="bottom-center" autoClose={3000} />
    </div>
  );
};

export default ContactForm;